import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import BenefitsSideBlock from '../../BenefitsSideBlock';
import OrderForm from '../../../containers/OrderFormWrapper/OrderFormWrapper';
import * as media from '../../../constants/mediaQueries';

const PrivatePolicyPageRightPart = (props) => {
  const { selectedLocations } = props;

  return (
    <div className="col-md-3">
      <div className="row">

        <MediaQuery minWidth={media.SCREEN_MD_MIN}>
          <div className="col-sm-6 col-md-12">
            {(selectedLocations.length > 0) && <OrderForm noScroll />}
          </div>
        </MediaQuery>

        <div className="col-sm-6 col-md-12">
          <BenefitsSideBlock />
        </div>

      </div>
    </div>
  );
};

PrivatePolicyPageRightPart.propTypes = {
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
};

PrivatePolicyPageRightPart.defaultProps = {
  selectedLocations: [],
};

export default PrivatePolicyPageRightPart;
